module.exports = __webpack_public_path__ + "img/21_26.f32621ad.png";